/* unplugin-vue-components disabled */import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.array.splice.js";
/* this file is transformed by vux-loader */
/* eslint-disable */
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.array.splice.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import CheckIcon from "vux/src/components/check-icon/index.vue"; // this line is trasformed by vux-loader
import UserLogo from '@/components/UserLogo';
// import Popup from '@/pages/mine/popup'
export default {
  components: {
    CheckIcon: CheckIcon,
    UserLogo: UserLogo
    // Popup
  },
  props: {
    imgUrl: String,
    statecolor: [String, Object],
    name: String,
    value: {
      type: [String, Number],
      default: ''
    },
    showflag: Boolean,
    logflag: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      isCheck: false
    };
  },
  computed: {
    // 是否是两行列表
    size: function size() {
      return this.$parent.$parent.size;
    },
    // 是否显示图片
    showImage: function showImage() {
      return this.$parent.$parent.showImage;
    },
    // 图片是否为圆形
    circleImage: function circleImage() {
      return this.$parent.$parent.circleImage;
    },
    // 是否开启多选
    check: function check() {
      return this.$parent.$parent.check;
    },
    miniStyle: function miniStyle() {
      var miniStyle = {};
      if (this.size === 'mini') {
        miniStyle.height = '4.8rem';
        miniStyle.padding = '.8rem 1rem';
        miniStyle.imgHeightWidth = '3.2rem';
        // miniStyle.contentMarginTop = '.24rem'
      } else if (this.size === 'normal') {
        miniStyle.height = '7.2rem';
        miniStyle.padding = '1.2rem 1rem';
        miniStyle.imgHeightWidth = '4.8rem';
        miniStyle.contentMarginTop = '.36rem';
      } else if (this.size === 'large') {
        miniStyle.height = '8.72rem';
        miniStyle.padding = '1.2rem 1rem';
        miniStyle.imgHeightWidth = '6.2rem';
        miniStyle.contentMarginTop = '.36rem';
      }
      if (this.circleImage) {
        miniStyle.imgBorderRadius = '50%';
      } else {
        miniStyle.imgBorderRadius = '.24rem';
      }
      return miniStyle;
    },
    // 选中列表
    checkList: {
      get: function get() {
        return this.$parent.$parent.checkList;
      },
      set: function set(newVal) {
        this.$parent.$parent.checkList = newVal;
      }
    }
  },
  watch: {
    // 将选中状态同步至checkList
    isCheck: function isCheck(val) {
      var index = this.checkList.indexOf(this.value);
      if (val) {
        if (index === -1) {
          this.checkList.push(this.value);
        }
      } else {
        if (index !== -1) {
          this.checkList.splice(index, 1);
        }
      }
    },
    checkList: function checkList(val) {
      if (val.indexOf(this.value) !== -1) {
        this.isCheck = true;
      } else {
        this.isCheck = false;
      }
    }
  },
  created: function created() {}
};